import React, { useCallback } from 'react'

import { RxCrossCircled } from 'react-icons/rx'

import Input from '@/Form/V2/Input'

import bemit from '@function/bemit'

export default function SearchBarV2 ({ onChange, name, ...props })
{
	const clear = useCallback(function (e)
	{
		onChange({ e: undefined, value: '' , name: name });
	},
	[onChange, name]);

	const handleChange = useCallback(function (e)
	{
		onChange({ e: e, value: e.target?.value || '', name: e.target?.name });
	},
	[onChange]);

	return (
		<div className={ bemit('c-searchbar-v2', props.bemit) }>

			<Input { ...props } name={ name }
				onChange={ handleChange }
				bemit={ (props['input-bemit'] || []).concat['searchbar-v2'] }
			/>

			<button type="button" className="c-searchbar-v2__clear"
				onClick={ clear }>
				<RxCrossCircled className="c-searchbar-v2__clear-icon" />
				<span className="u-readers-only">Effacer</span>
			</button>

		</div>
	);
}